{
  "en": {
    "ai": {
      "assistant": {
        "all_projects": "All projects",
        "cap": {
          "action": "Start a new conversation",
          "message": "You've reached the conversation limit."
        },
        "empty_state": {
          "subtitle": "Ask me anything about your clients",
          "title": "How can I help you?"
        },
        "errors": {
          "budget_reached": "The monthly AI budget for this workspace has been reached. Contact an administrator to raise the limit.",
          "generic": "Something went wrong. Please try again."
        },
        "history": {
          "empty": "No past conversations yet",
          "title": "Past conversations"
        },
        "input": {
          "disclaimer": "Results may be inaccurate. Always verify important information.",
          "hint": "Enter to send · Shift+Enter for new line",
          "placeholder": "Ask about your clients..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "How do I set up notifications?",
          "help_project_settings": "Where do I find project settings?",
          "open_decisions": "Which decisions are still open?",
          "unassigned_units": "Which units have no customer yet?"
        },
        "support_cta": {
          "action": "Contact support",
          "prompt": "Not the answer you were looking for?"
        }
      },
      "settings": {
        "budget": {
          "budget_label": "Budget",
          "description": "Monthly cost cap for AI usage (test phase). Recalculated based on token usage across all conversations this month.",
          "save": "Save",
          "title": "Monthly budget",
          "usage_label": "Used this month"
        },
        "description": "Configuration for AI features in your workspace.",
        "title": "AI settings"
      }
    }
  }
}
